import koncert1 from '../../files/images/photosPage/koncert1.jpg'
import koncert2 from '../../files/images/photosPage/koncert2.jpg'
import koncert3 from '../../files/images/photosPage/koncert3.jpg'
import koncert4 from '../../files/images/photosPage/koncert4.jpg'
import koncert5 from '../../files/images/photosPage/koncert5.jpg'
import koncert6 from '../../files/images/photosPage/koncert6.jpg'

const imagesSlider1 = [
    { image: koncert1, title: 'Aleksander Korecki gra na saksofonie'},
    { image: koncert2, title: 'Piotr Łojek gra na sentyzatorze'},
    { image: koncert3, title: 'Kuba Stankiewicz śpiewa'},
    { image: koncert4, title: 'Muzyk trzyma tamburyno'},
    { image: koncert5, title: 'Piotr Łojek gra na sentyzatorze'},
    { image: koncert6, title: 'Gitarzysta zespołu Elektryczne Gitary'},
  ];
  
  export default imagesSlider1;